import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";

/**
 * Tests for an exact permission value without restricting scope or owner IDs.
 *
 * Preconditions: The permission array is supplied.
 *
 * Postconditions: Returns whether any grant matches, without changing grants or establishing
 * server authorization.
 */
const hasPermissionAtAnyScope = (
    personnelTmdPermissions: PersonnelTmdPermission[],
    permission: Permission
): boolean => personnelTmdPermissions.some(item => item.permission === permission);

export default hasPermissionAtAnyScope;
